import { Injectable, Injector } from '@angular/core';
import { assert, isDefined } from '@sama/js-core';
import { matches } from '@sama/micro-dash';
import { InjectableSuperclass } from '@sama/ng-core';
import { values } from 'lodash';
import { isSensorFusionOutput } from '../../../../../cross-team-shared/misc-utils/output-utils';
import { TaskWorkspaceStore } from '../../../../h3ml/state/task-workspace-store';
import { FusionManager } from './fusion-manager';

@Injectable()
export class FusionManagerFactory extends InjectableSuperclass {
  private managers: StrictRecord<number, FusionManager> = {};

  constructor(
    private injector: Injector,
    private taskWorkspaceStore: TaskWorkspaceStore,
  ) {
    super();
  }

  getManager(outputId: number): FusionManager {
    return this.managers[outputId] ?? this.populateManager(outputId);
  }

  getManagers(): FusionManager[] {
    return values(this.managers).filter(isDefined);
  }

  private populateManager(outputId: number) {
    const { outputs } = this.taskWorkspaceStore.state().project;
    for (const sensorFusionOutput of outputs.filter(isSensorFusionOutput)) {
      if (
        sensorFusionOutput.meta.fused_outputs.find(
          matches({ output_id: outputId }),
        )
      ) {
        return this.getManager(sensorFusionOutput.id);
      }
    }

    const output = outputs.find(matches({ id: outputId }));
    assert(output, 'Tried creating a FusionManager for a non-existent output');

    const manager = new FusionManager(output, this.injector, this);
    this.managers[outputId] = manager;
    return manager;
  }
}
